module.exports = __webpack_public_path__ + "static/media/MacPortrait2w990@2x.3213a935.jpg";